import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useOcurrencesChartsDataContext } from './hooks/useOcurrencesChartsDataContext';

export const OcurrencesAnual = () => {
    const { chartData } = useOcurrencesChartsDataContext();

    const rawData = chartData?.ocurrencesAnual || [];

    const series = [
        {
            name: 'Total',
            data: rawData.map(item => Number(item.total || 0))
        },
        {
            name: 'Madrugada',
            data: rawData.map(item => Number(item.horario_madrugada || 0))
        },
        {
            name: 'Manhã',
            data: rawData.map(item => Number(item.horario_manha || 0))
        },
        {
            name: 'Tarde',
            data: rawData.map(item => Number(item.horario_tarde || 0))
        },
        {
            name: 'Noite',
            data: rawData.map(item => Number(item.horario_noite || 0))
        },
        {
            name: 'Não Identificado',
            data: rawData.map(item => Number(item.horario_nao_identificado || 0))
        }
    ];

    const categories = rawData.map(item => getYearLabel(item.ano));

    return (
        <SimpleBars
            title="Período das Ocorrências (Anual)"
            horizontal={false}
            stacked
            subtitles={categories}
            series={series}
            showDataLabels={false}
        />
    );
};
